export function htmlEncode(str) {
	return encodeURIComponent(str);
}

export function htmlDecode(str) {
	return decodeURIComponent(str);
}
